<template>
    <div class="d-flex align-items-center">
        <div class="flex-grow-1 flex-shrink-0">
            <editor-content :editor="editor" />
        </div>
        <div class="flex-grow-0 flex-shrink-0">
            <div v-if="editor" :editor="editor" class="w-100">
                <div class="btn-group" role="group">
                    <button
                        class="btn btn-light px-2 vitals-button-left"
                        @click="editor.chain().focus().toggleSubscript().run()"
                        :class="{ 'active': editor.isActive('subscript') }"
                    >
                        <span class="icon-lg icon icon-glyphicons-basic-subscript align-middle"></span>
                    </button>
                    <button
                        class="btn btn-light px-2"
                        @click="editor.chain().focus().toggleSuperscript().run()"
                        :class="{ 'active': editor.isActive('superscript') }"
                    >
                        <span class="icon-lg icon icon-glyphicons-basic-superscript align-middle"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Document from "@tiptap/extension-document"
import Paragraph from "@tiptap/extension-paragraph"
import Text from "@tiptap/extension-text"
import { Node } from "@tiptap/core";
import { Editor, EditorContent } from "@tiptap/vue-2"
import Subscript from "@tiptap/extension-subscript"
import Superscript from "@tiptap/extension-superscript"
import History from "@tiptap/extension-history"

// Custom node to confine the editor to a single line.
const OneLiner = Node.create({
  name: "oneLiner",
  topNode: true,
  content: "block",
});

export default {
    name: "RichText",
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    components: {
        EditorContent,
    },
    data() {
        return {
            editor: null,
        }
    },
    mounted() {
        this.editor = new Editor({
            content: this.value,
            editorProps: {
                attributes: {
                    class: "form-control vitals-sign-input",
                },
            },
            extensions: [OneLiner, Document, Paragraph, Text, Subscript, Superscript, History],
            // Reflect the current rich text html in the parent.
            onUpdate: () => {
                let html = this.editor.getHTML()
                // A blank input seems to produce an empty <p> element - using this check
                // emit value as an empty string.
                if (html == "<p></p>") {
                    this.$emit("input", "")
                } else {
                    this.$emit("input", html)
                }
            },
        })
    },
}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.vitals-sign-input {
    min-height: auto !important;
    min-width: 200px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    height: $input-height !important;
}
</style>

<style lang="scss" scoped>
.vitals-button-left {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}
</style>
